import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { DashboardOutletContextValue } from '../types/dashboard';

/** Nested routes under `/dashboard/statcrew/*` (overview, upload, assets). Forwards Dashboard outlet context. */
function StatCrewLayout() {
  const dashboardContext = useOutletContext<DashboardOutletContextValue>();
  return <Outlet context={dashboardContext} />;
}

export default StatCrewLayout;
